<template>
  <v-dialog
    :value="show"
    fullscreen
    hide-overlay
    transition="dialog-top-transition"
  >
    <v-card>
      <v-toolbar>
        <v-toolbar-title>{{ $t('title.validity_date') }}</v-toolbar-title>
        <v-spacer />
        <v-toolbar-items>
          <v-btn
            icon
            @click="close"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>

      <div class="subheading text-center pt-2">
        {{ $t('title.validity_date_selection') }}
      </div>

      <v-divider class="pa-1" />

      <v-time-picker
        v-model="timerPicker"
        full-width
        format="24hr"
      />

      <bottom-action
        btn-del
        btn-cancel
        btn-valid
        @del="$emit('del')"
        @cancel="$emit('cancel')"
        @valid="valid"
      />
    </v-card>
  </v-dialog>
</template>

<script>
import { MetierLocalStorage } from 'modulelocalstorage'

export default {
  name: 'TimerPickerDialog',

  model: {
    prop: 'show',
    event: 'change'
  },

  props: {
    show: { type: Boolean, default: false },
    btnClass: { type: String, default: null },
    btnColor: { type: String, default: null },
    useListener: { type: Boolean, default: true },
    defaultTimer: { type: String, default: null }
  },

  data () {
    return {
      timerPicker: null,
      locale: MetierLocalStorage.getLocale()
    }
  },

  watch: {
    defaultTimer (defaultTimer) {
      this.timerPicker = defaultTimer
    }
  },

  methods: {
    close () {
      this.$emit('del')
    },
    valid () {
      this.$emit('valid', this.timerPicker)
    }
  }
}
</script>
